import { releaseFixation, assignFixation } from '@/entities/fixation';
export async function releaseFixationAction(assignmentId) {
    await releaseFixation(assignmentId);
}
export async function assignFixationAction(agentId, managerId) {
    await assignFixation(agentId, managerId);
}
